module.exports = __webpack_public_path__ + "static/fonts/Simple-Line-Icons.0cb0b9c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SimpleLineIcons/Simple-Line-Icons.woff2?v=2.4.0
// module id = 1167
// module chunks = 5